// This optional code is used to register a service worker.
// register() is not called by default.

import {
  isAuthShellRoute,
  isPendingSecondFactorActive,
} from './features/two-factor-auth/utils/pendingSecondFactorSession';

function shouldSuppressAuthFlowReload() {
  try {
    return isAuthShellRoute() || isPendingSecondFactorActive();
  } catch {
    return false;
  }
}

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      registerValidSW(swUrl, config);
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl, { updateViaCache: 'none' }) // Prevent cache of service worker
    .then((registration) => {
      // Force update check on registration
      registration.update();

      // Check for updates every 30 seconds
      setInterval(() => {
        registration.update();
      }, 30000);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched
              console.log('New content is available and will be used automatically when all tabs for this page are closed.');

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }

              // Force immediate update without prompting
              if (registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
              }
            } else {
              // At this point, everything has been precached.
              console.log('Content is cached for offline use.');

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };

      // Handle controller change
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (shouldSuppressAuthFlowReload()) {
          console.log('Skipping service worker reload during login / pending 2FA');
          return;
        }
        console.log('New service worker controller, reloading...');
        window.location.reload();
      });
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

// Add immediate unregister function for development
export function unregisterImmediately() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        registration.unregister();
        // Clear all caches
        caches.keys().then(cacheNames => {
          return Promise.all(
            cacheNames.map(cacheName => caches.delete(cacheName))
          );
        });
      });
    });
  }
}

// Update your existing unregister function
export function unregister() {
  return new Promise((resolve) => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready
        .then((registration) => {
          return Promise.all([
            registration.unregister(),
            // Clear all caches
            caches.keys().then((cacheNames) => {
              return Promise.all(
                cacheNames.map((cacheName) => caches.delete(cacheName))
              );
            }),
          ]);
        })
        .then(() => resolve())
        .catch((error) => {
          console.error(error.message);
          resolve();
        });
    } else {
      resolve();
    }
  });
}

// Automatic refresh function that doesn't require user interaction
export function autoRefresh() {
  if ('serviceWorker' in navigator) {
    console.log('Auto refresh triggered');
    
    // Clear localStorage items that might be causing issues
    localStorage.removeItem('selectedCalendar');
    localStorage.removeItem('lastVersionCheck');
    localStorage.removeItem('lastCacheKey');
    localStorage.removeItem('lastInvalidationKey');
    
    // Force service worker update
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        registration.update();
        
        // If there's a waiting worker, activate it immediately
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      });
    });
    
    // Reload the page after a short delay
    setTimeout(() => {
      window.location.reload(true);
    }, 1000);
  }
}
